export const englishLevelCourses = [
  { value: -2, label: 'Discovery' },
  { value: -1, label: 'Adventures' },
  { value: 0, label: 'Pre A1' },
  { value: 0.5, label: 'Pre A1' },
  { value: 1.0, label: 'A1' },
  { value: 1.5, label: 'A1+' },
  { value: 2.0, label: 'A2' },
  { value: 2.5, label: 'A2+' },
  { value: 3.0, label: 'B1' },
  { value: 3.5, label: 'B1+' },
  { value: 4, label: 'B2' },
  { value: 4.5, label: 'B2+' },
  { value: 5, label: 'C1' },
  { value: 6, label: 'C2' },
];

export const MASTERTEST_DISTRIBUTOR_ID = '5cd1c5b645becc0013c62eba';

export const CURRENCY_MASK_OPTIONS = {
  real: {
    delimiter: '.',
    numeralDecimalMark: ',',
    symbol: 'R$',
  },
  dollar: {
    delimiter: ',',
    numeralDecimalMark: '.',
    symbol: 'U$',
  },
};

export const CONTRACT_PRODUCTS = Object.freeze({
  PREMIUM_PLAN: 'plano-premium',
  BEGINNER_PLAN: 'plano-beginner',
  ACTION_PLAN: 'plano-action',
  FLIGHT_PLAN: 'plano-fligth',
  PACKAGE_LICENSE: 'package-license',
  RISE_PLAN: 'plano-rise',
  STANDARD_PLAN: 'plano-standard',
  GROWTH_PLAN: 'plano-growth',
  ENTERPRISE_PLAN: 'plano-enterprise',
  TEACHERS_WEB_PAGE: 'teachers-web-page',
  PLACEMENT_TEST_COMERCIAL: 'placement-test',
  EXTRA_LICENSE: 'extra-license',
  EXTRA_LICENSE_SEAT: 'extra-license-seat',
  EXTRA_LICENSE_SEAT_PROPORTIONAL: 'extra-license-seat-proportional',
  EXTRA_LICENSE_KIDS: 'extra-license-kids',
  BASIC_SIGNATURE_3LOGINS: 'basic-signature-3logins',
  WHITELABEL_ACADEMIC_PARENTS: 'whitelabel-academic-parents',
  WHITELABEL_ACADEMIC: 'whitelabel-academic',
  WHITELABEL_ACADEMIC_KIDS_PARENTS: 'whitelabel-academic-kids-parents',
  EXTRA_LICENSES_RANGE: 'extra-license-range',
  EXTRA_LICENSES_SEAT_RANGE: 'extra-license-seat-range',
  CUSTOM_PACKAGE: 'custom-package',
  CANCELLATION_FINE: 'multa-cancelamento',
  FEATURE_VIDEO_LESSONS: 'feature-video-lessons',
  AI_EXERCISES: 'ai-exercises',
  OTHERS: 'others',
});

export const DOCUMENT_NUMBER_MASK_OPTIONS = {
  cpf: { delimiters: ['.', '.', '-'], blocks: [3, 3, 3, 3] },
  cnpj: { delimiters: ['.', '.', '/', '-'], blocks: [2, 3, 3, 4, 2] },
};

export const realCurrencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
export const dollarCurrencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export const BRAZIL = ['5a01ff39898e1571b5d5172b', '653271e525356705116d346d'];

export const HS_SKU_PRODUCTS_CAN_USE_INSTALLMENTS = [
  'whitelabel-academic-parents',
  'whitelabel-academic',
  'whitelabel-academic-kids-parents',
  'implementation-assistance',
  'whitelabel-update-fee',
  'modification-whitelabel',
  'others',
];

export const HS_SKU_PRODUCTS_CAN_BE_EDITED = [
  'placement-test',
  'teachers-web-page',
  'extra-license',
  'extra-license-seat',
  'extra-license-range',
  'extra-license-seat-range',
  'implementation-assistance',
  'feature-video-lessons',
  'others',
];

export const HS_SKU_PRODUCTS_CAN_BE_REMOVED_OR_ADDED_ON_EDIT = [
  'placement-test',
  'teachers-web-page',
  'implementation-assistance',
  'feature-video-lessons',
  'others',
];

export const HS_SKU_PRODUCTS_CAN_USE_FREE_AMOUNT = ['extra-license', 'placement-test', 'extra-license-seat'];

export const HS_SKU_PLAN_PRODUCTS = [
  'plano-premium',
  'plano-beginner',
  'plano-action',
  'plano-fligth',
  'plano-rise',
  'plano-standard',
  'plano-growth',
  'plano-enterprise',
  'basic-signature-3logins',
];
